<template>
  <div style="width: 100%;height: 24px;background-color: #EEB011;display: flex;align-items: center;justify-content: center;font-size: 12px;font-weight: 800;color: white;">
    BRANDS WE SERVICE
  </div>
  <div style="width: 100%;height: 100px;background-color: #595857;display: flex;align-items: center;justify-content: center;">
    <ImageCarousel :items="carouselItems" />
  </div>
  <nav class="pc-menu">
    <div class="nav-container">
      <div style="padding: 5px 10px;background-color: white;font-size: 20px;font-weight: 600;color: #595857;width: 120px;display: flex;align-items: center;justify-content: center;text-align: center;cursor: pointer;height: 60px;border-radius: 5px;" @click="menu('index')">
        <img src="https://alive-1302662846.cos.ap-nanjing.myqcloud.com/aliveusn/logo.png" style="width: 100%;height: 100%;">
      </div>
      <ul style="display: flex;align-items: center;">
        <li v-for="item in menuItems" :key="item.text">
          <a @click="menu(item.link)">{{ item.text }}</a>
        </li>
        <li class="phone-info" style="display: flex;align-items: center;">
          <img src="https://alive-1302662846.cos.ap-nanjing.myqcloud.com/others/24gf-phoneLoudspeaker%20%281%29.png">
          <span style="font-size: 24px;">905-738-4076</span>
        </li>
        <li class="hours-info" style="display: flex;flex-direction: column;justify-content: center;">
          <div style="font-weight: 800;font-size: 18px;" class="tips">Hours of Operation</div>
          <div style="font-size: 16px;margin-top: 5px;font-weight: 800;" class="tips">Monday-Friday 8:30 AM – 5:00 PM</div>
        </li>
        <li style="display: flex;align-items: center;">
          <div class="qr-block">
            <img 
              src="https://alive-1302662846.cos.ap-nanjing.myqcloud.com/1741324738676./website.png" 
              alt="Scan to get free quote"
              style="height: 70px;border-radius: 4px;"
            />
          </div>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
import ImageCarousel from '@/components/ImageCarousel2.vue'
import { removeValue } from '@/utils/auth';
export default {
  components: {
    ImageCarousel
  },
  data() {
    return {
      menuItems: [
        // { text: 'Work Order', link: 'order' },
        { text: 'Management', link: 'login' },
      ],
      carouselItems: [
        'https://alive-1302662846.cos.ap-nanjing.myqcloud.com/maintain/1.png',
        'https://alive-1302662846.cos.ap-nanjing.myqcloud.com/maintain/2.png',
        'https://alive-1302662846.cos.ap-nanjing.myqcloud.com/maintain/3.png',
        'https://alive-1302662846.cos.ap-nanjing.myqcloud.com/maintain/4.png',
        'https://alive-1302662846.cos.ap-nanjing.myqcloud.com/maintain/5.png',
        'https://alive-1302662846.cos.ap-nanjing.myqcloud.com/maintain/6.png',
        'https://alive-1302662846.cos.ap-nanjing.myqcloud.com/maintain/7.png',
        'https://alive-1302662846.cos.ap-nanjing.myqcloud.com/maintain/8.png',
        'https://alive-1302662846.cos.ap-nanjing.myqcloud.com/maintain/9.png',
        'https://alive-1302662846.cos.ap-nanjing.myqcloud.com/maintain/10.png',
        'https://alive-1302662846.cos.ap-nanjing.myqcloud.com/maintain/11.png',
        'https://alive-1302662846.cos.ap-nanjing.myqcloud.com/maintain/12.png',
        'https://alive-1302662846.cos.ap-nanjing.myqcloud.com/maintain/13.png', 
        'https://alive-1302662846.cos.ap-nanjing.myqcloud.com/maintain/14.png',
        'https://alive-1302662846.cos.ap-nanjing.myqcloud.com/maintain/15.png',
        'https://alive-1302662846.cos.ap-nanjing.myqcloud.com/maintain/16.png',
        'https://alive-1302662846.cos.ap-nanjing.myqcloud.com/maintain/17.png',
        'https://alive-1302662846.cos.ap-nanjing.myqcloud.com/maintain/18.png',
        'https://alive-1302662846.cos.ap-nanjing.myqcloud.com/maintain/19.png',
        'https://alive-1302662846.cos.ap-nanjing.myqcloud.com/maintain/20.png',
        'https://alive-1302662846.cos.ap-nanjing.myqcloud.com/maintain/21.png',
        'https://alive-1302662846.cos.ap-nanjing.myqcloud.com/maintain/22.png',
        'https://alive-1302662846.cos.ap-nanjing.myqcloud.com/maintain/23.png',
      ],
    };
  },
  methods: {
    menu(name) {
      const keepAuthRoutes = ['menus', 'adminmenus', 'dispatchmenus', 'goods']
      if (!keepAuthRoutes.includes(name)) {
        removeValue('maintain-role');
        removeValue('maintain-token');
      }
      this.$router.push({ name: name });
    }
  }
};
</script>

<style scoped>
.pc-menu {
  width: 100%;
  background: #007FFF;
  padding: 5px 0;
  z-index: 100;
}

.nav-container {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  margin: 8px auto;
}

.pc-menu ul {
  list-style: none;
  display: flex;
  align-items: center;
}

.pc-menu li {
  margin: 0 30px;
  color: white;
  display: flex;
  align-items: center;
}

.phone-info {
  display: flex;
  align-items: center;
  margin-left: 30px;
}

.phone-info img {
  width: 24px;
  height: 24px;
}

.phone-info span {
  margin-left: 10px;
}

.hours-info {
  width: 300px;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.pc-menu a:hover {
  color: #EEB011;
}

.pc-menu a {
  color: white;
  text-decoration: none;
  font-size: 20px;
  font-weight: 600;
  cursor: pointer;
}

.tips{
  color: #fab402;
}
</style>